/**
 * Responsável por adicionar os markers de Arrivals no mapa.
 * Created by igor on 10/7/18.
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.MapLayerActions = Greenmile.Toolbar.MapLayerActions || {};

Greenmile.Toolbar.MapLayerActions.Arrival = (() => {

    function ArrivalLayer () {

        Greenmile.Toolbar.MapLayerActions.Base.apply(this, arguments);

        this.LAYER_NAME = 'arrival';
        this.RESOURCE_LAYER = 'routeDetails.stopDetailsPopup.zones.arrivalLocation';

        let instanceToDataClass = null;

        this.setInstanceToClassData = function (instance) {
            instanceToDataClass = instance;
        };

        this.afterClickOnCheckBox = (element) => {

            const _element = element.target;
            const status = !!_element.checked;

            if(instanceToDataClass) {
                if(status) {
                    instanceToDataClass.getArrivalsAndDrawOnMap();
                } else {
                    instanceToDataClass.removeArrivalsFromMap();
                }
            }

            this.fireEvent("afterClickOnCheckBox");
        };

    }

    return ArrivalLayer;


})();
